module.exports = __webpack_public_path__ + "media/images/about_us/service-c5bb3e4edc632a1fb45d8a9d2b4a5873.jpg";